:host {
  display: block;
  translate: 0 8px !important;

  sy-text {
    padding: 4px 40px;
    margin-bottom: 8px;
  }

  sy-divider {
    margin-top: 4px;
  }

  .logout {
    display: block;
    padding-top: 8px;
    padding-bottom: 4px;
    margin-bottom: 16px;

    --sy-heading-h6-font-weight: 400;

    &:hover {
      cursor: pointer;
      background: #e9ecef linear-gradient(180deg, rgb(233 236 239 / 85%), #e9ecef) repeat-x;
    }
  }
}
